import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";

import { LoadingComponent } from "../components/common";
import SidebarComponent from "../components/home/sidebarComponent";
import ManagerUserAccessComponent from "../components/setting/managerUserAccessComponent";
import { SessionUserStyles } from "./PagesStyle";

class ManagerUserAccessComponentPage extends Component {
	render() {
		const { classes, isLoading, mixpanel } = this.props;

		return (
			<div className={classes.root}>
				<CssBaseline />
				<SidebarComponent />
				<main className={classes.content}>
					<LoadingComponent isLoading={isLoading} />
					<div className={classes.appBarSpacer} />
					<ManagerUserAccessComponent mixpanel={mixpanel} />
				</main>
			</div>
		);
	}
}

ManagerUserAccessComponentPage.propTypes = {
	classes: PropTypes.object.isRequired,
	isLoading: PropTypes.bool
};

const mapStateToProps = state => ({
	isLoading: state.employer.isLoading
});

export default connect(
	mapStateToProps,
	null
)(withStyles(SessionUserStyles)(ManagerUserAccessComponentPage));
